var _module = require('../components/module');

/*
monthlyCost
Takes a number and calculates the ~monthly cost of
that number.
*/
_module.filter('monthlyCost', function () {
    return function monthlyCost(str) {
        var amountDown = 0.2;
        var price = -(parseFloat(str) * (1 - amountDown));
        var months = 30 * 12;
        var interest = 3.5 / 1200;

        return (interest * price * Math.pow((1 + interest), months) / (1 - Math.pow((1 + interest), months))).toFixed(2);
    };
});
